import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/reagendamento-medico`

    return {
        datatable(params = {}) {
            return repository.post(`${baseUrl}/datatable`, params)
        },
        edit(usuarioId) {
            return repository.get(`${baseUrl}/${usuarioId}/edit`)
        },
        list(params) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(params)}`)
        },
        store(params) {
            return repository.post(baseUrl, params)
        },
    }
}
